import React, { useState } from 'react';

import { IntlProvider } from 'react-intl';
import messages_en from '../Assets/i18n/en.json';
import messages_nl from '../Assets/i18n/nl.json';

export interface ITranslationProvider {
  children: React.ReactNode;
}
interface ILocaleContext {
  locale: string;
  changeLocale: TChangeLocale;
}

type TChangeLocale = (localeInput?: string | undefined) => void;

const messages = {
  'nl-NL': { ...messages_en, ...messages_nl },
  'en-GB': messages_en,
  'en-US': messages_en,
} as const;

const LocaleContext = React.createContext({} as ILocaleContext);

export default function TranslationProvider({
  children,
}: ITranslationProvider) {
  const defaultLng = 'nl-NL';
  const [locale, setLocale] = useState(defaultLng);

  const ChangeLocale = (localeInput?: string) => {
    if (localeInput) {
      setLocale(localeInput);
    }
  };

  return (
    <LocaleContext.Provider value={{ locale, changeLocale: ChangeLocale }}>
      <IntlProvider
        locale={locale}
        defaultLocale={defaultLng}
        messages={messages[locale as keyof typeof messages]}
      >
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
}
